module.exports = __webpack_public_path__ + "img/mobile-communities.3cbf0258.png";